import React from "react";
import GraphQLErrorList from "../components/graphql-error-list";
import SEO from "../components/seo";
import Layout from "../containers/layout";
import QFaqPage from "../queries/QFaqPage";
import FaqPage from "../components/faq-page";
import { toPlainText } from "../lib/helpers";

// Added 2026-09-23: FAQPage JSON-LD is the highest-leverage schema type for
// AI Overviews/AI search specifically, since it maps directly onto content
// this page already has (question/answer pairs) — no new Sanity field
// needed, just reshaping what QFaqPage already fetches. `answer` is
// portable text, so it's flattened to plain text via the existing
// `toPlainText` helper (schema.org's Answer.text wants a plain string).
function buildFaqSchema(questionsAndAnswers) {
  const items = (questionsAndAnswers || []).filter((item) => item.question && item.answer);
  if (items.length === 0) return [];

  return [
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: items.map((item) => ({
        "@type": "Question",
        name: item.question,
        acceptedAnswer: {
          "@type": "Answer",
          text: toPlainText(item.answer),
        },
      })),
    },
  ];
}

const Faq = (props) => {
  const { data, errors } = props;

  if (errors) {
    return (
      <Layout>
        <GraphQLErrorList errors={errors} />
      </Layout>
    );
  }

  return (
    <QFaqPage>
      {({ faqPage }) => (
        <Layout>
          <SEO
            title={faqPage.pageTitle}
            schema={buildFaqSchema(faqPage._rawQuestionsAndAnswers)}
          />
          <FaqPage {...faqPage} />
        </Layout>
      )}
    </QFaqPage>
  );
};

export default Faq;
